"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _Tooltip = _interopRequireWildcard(require("../../../../../../../ui/Tooltip"));
var _Button = _interopRequireDefault(require("../../../../../../../ui/Button"));
var _actions = require("../../store/actions");
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var Svg = _styledComponents.default.svg.attrs({
  width: '20',
  height: '20',
  viewBox: '0 0 20 20',
  xmlns: 'http://www.w3.org/2000/svg'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    :hover > path {\n        fill: ", ";\n    }\n"])), function (props) {
  return props.theme.primaryColor;
});
var CopyIcon = function CopyIcon() {
  return /*#__PURE__*/_react.default.createElement(Svg, null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.91603 14.896C7.37403 14.896 6.9087 14.7013 6.52003 14.312C6.13136 13.9233 5.93703 13.4583 5.93703 12.917V3.354C5.93703 2.81267 6.13136 2.34733 6.52003 1.958C6.9087 1.56933 7.37403 1.375 7.91603 1.375H14.978C15.52 1.375 15.9854 1.56933 16.374 1.958C16.7627 2.34733 16.957 2.81267 16.957 3.354V12.917C16.957 13.4583 16.7627 13.9233 16.374 14.312C15.9854 14.7013 15.52 14.896 14.978 14.896H7.91603ZM7.91603 12.917H14.978V3.354H7.91603V12.917ZM4.18703 18.625C3.64503 18.625 3.1797 18.4307 2.79103 18.042C2.4017 17.6527 2.20703 17.1873 2.20703 16.646V6.167C2.20703 5.903 2.3077 5.67367 2.50903 5.479C2.71036 5.285 2.94303 5.188 3.20703 5.188C3.47103 5.188 3.70036 5.285 3.89503 5.479C4.0897 5.67367 4.18703 5.903 4.18703 6.167V16.646H12.166C12.4294 16.646 12.6584 16.7433 12.853 16.938C13.0477 17.132 13.145 17.361 13.145 17.625C13.145 17.889 13.0477 18.1217 12.853 18.323C12.6584 18.5243 12.4294 18.625 12.166 18.625H4.18703ZM7.91603 3.354V12.917V3.354Z"
  }));
};
var CopyButton = function CopyButton(_ref) {
  var offerID = _ref.offerID,
    basketID = _ref.basketID;
  var _useTranslation = (0, _reactI18next.useTranslation)('BASKET_EDIT_FORM'),
    t = _useTranslation.t;
  var dispatch = (0, _reactRedux.useDispatch)();
  var onClick = (0, _react.useCallback)(function () {
    dispatch((0, _actions.copyOfferToBuffer)(offerID, basketID));
  }, [basketID, dispatch, offerID]);
  return /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: t('COPY_BUTTON_TITLE'),
    placement: _Tooltip.PLACEMENTS.TOP,
    trigger: [_Tooltip.TRIGGERS.HOVER]
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    icon: /*#__PURE__*/_react.default.createElement(CopyIcon, null),
    onClick: onClick
  }));
};
CopyButton.propTypes = {
  offerID: _propTypes.default.string.isRequired,
  basketID: _propTypes.default.number.isRequired
};
var _default = exports.default = (0, _react.memo)(CopyButton);